import { useContext } from "react";
import { MyContext } from "../context/myContext";
import {useDispatch} from "react-redux";
import {changeRegisterBtnType} from "../features/common-states/commonStatesSlice";

const FormFooter = ({ handleReset }) => {
    const { formTitle, handleShowForm, registerBtn, content } = useContext(MyContext);
    const dispatch = useDispatch()
    return (
        <div className="form-footer">
            <div className='text-left'>
                <button className="mr-1 md:mr-2 bg-red-500 button-styles text-xs sm:text-sm hover:bg-red-600" type="button" onClick={handleShowForm}>
                    انصراف
                </button>
                {(registerBtn === 'ویرایش اطلاعات' || registerBtn === 'ثبت اطلاعات') &&
                    <button type='submit' className={`button-styles mr-2 text-xs sm:text-sm ${registerBtn === 'ویرایش اطلاعات' ? 'bg-blue-400 hover:bg-blue-500' : 'bg-orange-400 hover:bg-orange-500'}`}
                            onClick={() => dispatch(changeRegisterBtnType(registerBtn === 'ویرایش اطلاعات' ? 'تایید تحویل' : 'رد درخواست'))}
                    >
                        {registerBtn === 'ویرایش اطلاعات' ? 'تایید تحویل' : 'رد درخواست'}
                    </button>
                }
                {content !== 'ثبت تحویل آب توسط کاربر' && content !== 'این درخواست رد شده است' &&
                    <button className="bg-green-600 button-styles text-xs sm:text-sm hover:bg-green-700" type="submit" onClick={() => formTitle !== 'افزودن درخواست جدید' && formTitle !== 'تغییر رمزعبور' && dispatch(changeRegisterBtnType(registerBtn ?? 'ثبت'))}>
                        {registerBtn ?? 'ثبت'}
                    </button>
                }
                {(formTitle === "تعریف کاربر جدید" || formTitle === 'ویرایش کاربر') && (
                    <button className="button-styles bg-gray-700 text-xs sm:text-sm ml-2 hover:bg-gray-900" type="button" onClick={handleReset}>
                        پاکسازی فرم
                    </button>
                )}
            </div>
            <p className='ml-auto text-red-500 text-[10px] sm:text-sm flex gap-1'>موارد نشان دار الزامی هستند<span>*</span></p>
        </div>
    );
};

export default FormFooter;